import { Box } from '@mui/material';

const PostingTabToolbar = ({ searchBar, filters }) => (
  <Box
    sx={{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '0px 24px',
      margin: '16px 0px 24px',
      height: '100%',
    }}
  >
    <Box sx={{ width: '100%' }}>{searchBar}</Box>
    <Box pl={3}>{filters}</Box>
  </Box>
);

export default PostingTabToolbar;
